"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictionRuleDisallowedWhen = void 0;
const _ = require("lodash");
const _1 = require("./");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
/**
 * Restriction Rule: DisallowedWhen
 *
 * This rule limits certain item’s availability based on if certain other items
 * have been chosen or not. For example, if a burrito has a vegetarian
 * options it makes no sense to add extra meat so we disallow this. And
 * conversely if a person chooses a meat option then it makes no sense to
 * choose the vegetarian.
 */
class RestrictionRuleDisallowedWhen {
    constructor(data) {
        this.name = _1.TRestrictionRuleName.disallowedWhen;
        if (data) {
            this.productIds = data.productIds;
            this.dependencies = data.dependencies;
        }
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            name: this.name,
            productIds: this.productIds,
            dependencies: this.dependencies
        };
    }
    static unserialize(data) {
        const newRestrictionRuleDisallowedWhen = new this();
        newRestrictionRuleDisallowedWhen.productIds = data.productIds;
        newRestrictionRuleDisallowedWhen.dependencies = data.dependencies;
        return newRestrictionRuleDisallowedWhen;
    }
    isValid(products, productAvailability, selectedProducts) {
        const isAnyDependencySelected = this._isAnyDependencySelected(selectedProducts);
        const isAnyProductSelected = this._isAnyProductSelected(selectedProducts);
        if (!isAnyDependencySelected && !isAnyProductSelected) {
            return true;
        }
        if (isAnyDependencySelected) {
            return !isAnyProductSelected;
        }
        return isAnyProductSelected;
    }
    apply(products, productAvailability, selectedProducts) {
        const isAnyProductSelected = this._isAnyProductSelected(selectedProducts);
        const isAnyDependencySelected = this._isAnyDependencySelected(selectedProducts);
        if (isAnyProductSelected) {
            this._removeFromProductSelections(selectedProducts);
            this._updateProductAvailability(productAvailability, this.dependencies);
        }
        if (isAnyDependencySelected) {
            this._removeFromProductSelections(selectedProducts);
            this._updateProductAvailability(productAvailability, this.productIds);
        }
    }
    _removeFromProductSelections(selectedProducts) {
        const originalSelectedProducts = _.cloneDeep(selectedProducts);
        let productIds = [];
        const productSelected = this._isProductSelected(originalSelectedProducts);
        if (productSelected) {
            productIds = this.dependencies;
        }
        const dependencySelected = this._isDependencySelected(originalSelectedProducts);
        if (dependencySelected) {
            productIds = this.productIds;
        }
        if (productSelected || dependencySelected) {
            originalSelectedProducts.map((originalSelectedProduct) => {
                if (productIds.includes(originalSelectedProduct.product.productId)) {
                    const index = selectedProducts.findIndex((selectedProduct) => selectedProduct.product.productId ===
                        originalSelectedProduct.product.productId);
                    if (index !== -1) {
                        selectedProducts.splice(index, 1);
                    }
                }
            });
        }
    }
    _updateProductAvailability(productAvailabilities, productIds) {
        productAvailabilities.map((productAvailability) => {
            if (productIds.includes(productAvailability.productId)) {
                productAvailability.canAdd = true;
            }
        });
    }
    _isAnyProductSelected(selectedProducts) {
        return selectedProducts.some(sp => this.productIds.indexOf(sp.product.productId) !== -1 && sp.quantity > 0);
    }
    _isAnyDependencySelected(selectedProducts) {
        return selectedProducts.some(sp => this.dependencies.indexOf(sp.product.productId) !== -1 &&
            sp.quantity > 0);
    }
    _isProductSelected(selectedProducts) {
        const lastSelection = selectedProducts[selectedProducts.length - 1];
        if (lastSelection) {
            const { product: { productId }, quantity } = lastSelection;
            return this.productIds.includes(productId) && quantity > 0
                ? productId
                : null;
        }
        return null;
    }
    _isDependencySelected(selectedProducts) {
        const lastSelection = selectedProducts[selectedProducts.length - 1];
        if (lastSelection) {
            const { product: { productId }, quantity } = lastSelection;
            return this.dependencies.includes(productId) && quantity > 0
                ? productId
                : null;
        }
        return null;
    }
}
exports.RestrictionRuleDisallowedWhen = RestrictionRuleDisallowedWhen;
//# sourceMappingURL=RestrictionRuleDisallowedWhen.js.map